import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, TextElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type TextProps = RecursivePartial<
  Omit<TextElement["attributes"], "children">
> & {
  idx?: string | null;
  children?: ElementChildren | TextElement["children"] | string;
  data?: TextElement["data"];
};

export function Text(props: TextProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: TextElement = {
    type: BasicType.TEXT,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
